/**
 * WordPress Dependencies
 */
import { store, getElement, getContext } from '@wordpress/interactivity';

store('prc-rls/chart-provider', {
	state: {
		get isActive() {
			const context = getContext();
			const element = getElement();
			return (
				element.attributes['data-chart-view'] === context.activeTab ||
				element.attributes['data-chart-view'].includes(
					context.activeTab
				)
			);
		},
		get isSelectedVariable() {
			const context = getContext();
			const element = getElement();
			return (
				element.attributes['data-independent-var'] ===
				context.selectedVariable
			);
		},
	},
	actions: {
		setSelectedVariable() {
			const context = getContext();
			const element = getElement();
			context.selectedVariable =
				element.attributes['data-independent-var'];
		},
		setActiveTab() {
			const context = getContext();
			const element = getElement();
			context.activeTab = element.attributes['data-chart-view'];
		},
		toggleQuestionExpanded() {
			const context = getContext();
			context.isQuestionExpanded = !context.isQuestionExpanded;
		},
		hideModal() {
			const context = getContext();
			context.activeTab = 'chart';
		},
	},
	callbacks: {
		onRun: () => {},
	},
});
